// Pricing policy + ladder step type.

/** What a catalogue row is holding — the sentence above „Usuń pozycję". */
export type { OfferingUse } from '@repo/db/queries/offering'
export { type CodeService, createCodeService } from './codes.service.ts'
// Spec §14's hand-minted codes: what they take off, and why one bounces.
export {
  type CodeBasket,
  codeDiscountMinor,
  codeProblem,
  MAX_DISCOUNT_BPS,
} from './codes.ts'
export {
  DEFAULT_PRICING_POLICY,
  DEFAULT_TAX_RATE_BPS,
  type LadderStep,
  type PricingPolicy,
  type RoundingMode,
} from './constants.ts'
// Spec §13's Koordynator: when one is offered, when one is compulsory, and
// what 12% is 12% OF.
export {
  COORDINATOR_COMPULSORY_FROM,
  COORDINATOR_FEE_BPS,
  COORDINATOR_LABEL,
  COORDINATOR_MIN_FEE_MINOR,
  COORDINATOR_OPTIONAL_FROM,
  COORDINATOR_UNIT_LABEL,
  type CoordinatorLine,
  type CoordinatorMode,
  coordinatorBaseMinor,
  coordinatorFeeMinor,
  coordinatorMode,
  coordinatorPieces,
  countsTowardCoordinator,
  wantsCoordinator,
} from './coordinator.ts'
// Spec §8's length bands: what a film costs up front and how long it may run.
export {
  bandAt,
  bandForMinutes,
  bandLabel,
  bandValueText,
  isWithinBand,
  LENGTH_BANDS,
  type LengthBand,
  overageMinutes,
  overageNetMinor,
  paidMinutesFor,
} from './film-pricing.ts'
// Spec §8's raw-footage allowance and the flat fee for going over it.
export {
  FOOTAGE_MINUTES_PER_REEL,
  FOOTAGE_OVERAGE_NET_MINOR,
  FOOTAGE_RATIO,
  filmFootageLimit,
  footageLimitFor,
  footageOverageMinutes,
  footageOverageNetMinor,
  footageRatioFor,
  reelFootageLimit,
} from './footage-limit.ts'
// Read model + mappers.
export {
  type BookingMode,
  type BriefMode,
  type City,
  type CoverageMode,
  type DiscountKind,
  type FeatureGrant,
  type Offering,
  type OfferingCategory,
  type OfferingDetail,
  type OfferingFeature,
  type OfferingVariant,
  type PricingUnit,
  type QuoteOption,
  type SourceMode,
  toCity,
  toOffering,
  toOfferingCategory,
  toOfferingVariant,
} from './mappers.ts'
// Guarded use-cases.
export {
  createOfferingService,
  type OfferingService,
  type RentalLadderWrite,
} from './offering.service.ts'
// Order recompute.
export {
  type OrderLineInput,
  type OrderQuote,
  type OrderQuoteLine,
  quoteOrder,
} from './orders-pricing.ts'
// Pure engine.
export {
  type CartLine,
  type CartTotals,
  cartTotals,
  countDays,
  dayWord,
  grossMinor,
  roundMinor,
  vatOf,
} from './pricing-engine.ts'
// Zod input schemas.
export {
  CreateCategoryInput,
  CreateCityInput,
  CreateDiscountCodeInput,
  CreateFeatureInput,
  CreateOfferingInput,
  CreateQuoteOptionInput,
  CreateVariantInput,
  SetOfferingCitiesInput,
  SlugSchema,
  UpdateCategoryInput,
  UpdateCityInput,
  UpdateDiscountStepInput,
  UpdateFeatureInput,
  UpdateOfferingInput,
  UpdateQuoteOptionInput,
  UpdateVariantInput,
} from './schemas.ts'
// Validators.
export { assertPriced } from './validators.ts'
